import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    alert("Thank you for your message! We will get back to you soon.");
    setFormData({
      name: "",
      email: "",
      phone: "",
      company: "",
      subject: "",
      message: "",
    });
  };

  const contactInfo = [
    {
      icon: faPhone,
      title: "Phone",
      details: ["+91 94081 86116"],
      link: "tel:+919408186116",
    },
    {
      icon: faEnvelope,
      title: "Email",
      details: ["rkrwankaner@yahoo.co.in"],
      link: "mailto:rkrwankaner@yahoo.co.in",
    },
    {
      icon: faMapMarkerAlt,
      title: "Address",
      details: [
        "Opp. Railway Station, Visipara",
        "Wankaner - 363621",
        "Gujarat, India",
      ],
      link: "#",
    },
    {
      icon: faClock,
      title: "Business Hours",
      details: ["Monday - Sunday: 24 Hours", "Wendnesday: weekly off"],
      link: "#",
    },
  ];

  return (
    <div className="contact">
      <div className="contact-hero">
        <div className="container">
          <h1>Contact Us</h1>
          <p>Get in touch with us for all your firebricks requirements</p>
        </div>
      </div>

      <div className="container">
        <div className="contact-content">
          {/* Contact Information */}
          <div className="contact-info">
            <h2>Get In Touch</h2>
            <p>
              We're here to help you with all your firebricks manufacturing
              needs. Contact us today for a consultation or quote.
            </p>

            <div className="info-grid">
              {contactInfo.map((info, index) => (
                <div key={index} className="info-card">
                  <div className="info-icon">
                    <FontAwesomeIcon icon={info.icon} />
                  </div>
                  <div className="info-content">
                    <h3>{info.title}</h3>
                    {info.details.map((detail, idx) => (
                      <p key={idx}>{detail}</p>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="company-highlights">
              <h3>Why Choose Us?</h3>
              <ul>
                <li>50+ years of industry experience</li>
                <li>ISO certified manufacturing processes</li>
                <li>Custom solutions for specific requirements</li>
                <li>Timely delivery across India</li>
                <li>24/7 technical support</li>
                <li>Competitive pricing</li>
              </ul>
            </div> */}
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            <h2>Send Us a Message</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <select
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a subject</option>
                  <option value="quote">Request for Quote</option>
                  <option value="product">Product Information</option>
                  <option value="technical">Technical Support</option>
                  <option value="custom">Custom Requirements</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Please describe your requirements in detail..."
                  required
                ></textarea>
              </div>

              <button type="submit" className="btn btn-primary">
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Map Section */}
        <div className="map-section">
          <h2>Our Location</h2>
          <div className="">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.9190626944983!2d70.96688489999998!3d22.619497400000018!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395997ee01890d0d%3A0x5e822fbc5ec4e81f!2sRamkrishna%20I%20Refractories!5e0!3m2!1sen!2sin!4v1751711020691!5m2!1sen!2sin"
              width="100%"
              height="450"
              style={{ border: "0;" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* FAQ Section */}
        {/* <div className="faq-section">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h4>What types of firebricks do you manufacture?</h4>
              <p>
                We manufacture a wide range of firebricks including High
                Alumina, Silica, Magnesia, Insulating, Chrome-Magnesia, and
                Zirconia firebricks for various industrial applications.
              </p>
            </div>
            <div className="faq-item">
              <h4>Do you provide custom firebricks solutions?</h4>
              <p>
                Yes, we specialize in manufacturing custom firebricks tailored
                to your specific requirements and applications.
              </p>
            </div>
            <div className="faq-item">
              <h4>What is your delivery timeline?</h4>
              <p>
                Standard orders are typically delivered within 7-14 days. Custom
                orders may take 2-4 weeks depending on complexity.
              </p>
            </div>
            <div className="faq-item">
              <h4>Do you export internationally?</h4>
              <p>
                Yes, we export our products to various countries across Asia,
                Europe, and other international markets.
              </p>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Contact;
